import React, { memo } from "react";
import { lighten, darken } from "@mui/material/styles";
import { styled } from "@mui/system";
import { Box, Tooltip, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const wingName = {
  356: "Ventas Squad",
  282: "Deal Maestro",
  371: "Goal Setters",
  680: "ECPC",
  552: "Chaser Crew",
};

const hoverDetails = {
  foundation: 100,
  speakPro: 200,
  "little Giene": 20,
};
const OgmDashboardCardView = memo(
  ({
    name,
    color,
    assessmentReportGenerated,
    assessmentTaken,
    clickFunction,
    delay = 0,
    userId,
    admissinCount,
    admissinUnconfirmed,
    revenue,
    saleAmount,
    tar,
    sfr,
    acr,
    arpu,
    courseEnrollment
  }) => {
    const teamName = wingName[userId] || "";
    const GradientCard = styled(motion.div)(({ color, theme }) => ({
      background: `linear-gradient(to right, ${lighten(color, 0.3)}, ${darken(
        color,
        0.3
      )})`,
      color: theme.palette.getContrastText(lighten(color, 0.1)),
      padding: "24px",
      // height: theme.spacing(20),
      borderRadius: "12px",
      // boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      "&:hover": {
        transform: "scale(1.05)",
        boxShadow: "6px 6px 4px 0 black",
      },
    }));

    const NameTeamWrapper = styled(Box)({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "12px",
      padding: "10px 20px 10px 20px",
      marginBottom: "16px",
      background:
        "linear-gradient(135deg, rgba(0, 139, 208, 0.62), rgba(160, 37, 194, 0.65))",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      minWidth: "200px",
    });

    const TitleTypography = styled(Typography)(({ theme }) => ({
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 600,
      marginBottom: theme.spacing(1),
      color: "white",
      paddingTop: "6px ",
    }));

    const StatTypography = styled(Typography)(({ theme }) => ({
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 500,
      marginBottom: theme.spacing(0.5),
    }));

    const TeamTypography = styled(Typography)({
      fontSize: "19px",
      fontWeight: 700, // Bolder text
      textTransform: "uppercase",
      letterSpacing: "1px",
      // background: "linear-gradient(90deg,rgb(107, 110, 111),rgb(217, 220, 234))",
      // WebkitBackgroundClip: "text",
      // WebkitTextFillColor: "transparent",
      textShadow: "1px 1px 1px rgba(253, 249, 255, 0.96)",
      color: "white",
      padding: "10px 19px",
      borderRadius: "8px",
      textAlign: "center",
      border: "1px solid #5945af",
    });



    return (
      <GradientCard
        initial={{ y: -200, x: 0, opacity: 0 }} // Start higher and slightly offset horizontally
        animate={{ y: 0, x: 0, opacity: 1 }} // Drop to original position
        transition={{ duration: 0.5, delay }} // Smooth transition with delay
        color={color}
        onClick={() => clickFunction(userId)}
      >
        <NameTeamWrapper>
          <TeamTypography>{teamName}</TeamTypography>
          <TitleTypography>{name}</TitleTypography>
        </NameTeamWrapper>
        <Box sx={{display:'flex',flexDirection:'column',}}>
          {/* <StatTypography>
            Admission UnConfirmed : <strong>{admissinUnconfirmed}</strong>
          </StatTypography> */}
          <Tooltip
              // title={
              //   <Box
              //     sx={{
              //       bgcolor: "white",
              //       color: "black",
              //       p: 1,
              //       borderRadius: "4px",
              //       boxShadow: 3,
              //       minWidth: "120px",
              //     }}
              //   >
              //     {Object.entries(hoverDetails).map(([key, value]) => (
              //       <Typography key={key} variant="body2">
              //         {key}: {value}
              //       </Typography>
              //     ))}
              //   </Box>
              // }
              // arrow
            >
              {/* <StatTypography>
                Admission Confirmed : <strong>{admissinCount}</strong>
              </StatTypography> */}
            </Tooltip>
            <StatTypography>
            Course Enrollment : <strong>{courseEnrollment}</strong>
          </StatTypography>
        </Box>
        
        
        
        
        <Box border={1} mt={1} 
        // sx={{ display: "flex", justifyContent: "space-between" ,width:'100%'}}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          bgcolor: "rgba(255, 255, 255, 0.1)", // Light background highlight
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Soft shadow effect
          borderRadius: "8px", // Rounded corners for better UI
          p: 2, // Padding for better spacing
          borderColor: "rgba(255, 255, 255, 0.3)", // Lighter border effect
        }}
        >
          <Box
        
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Tooltip title={"Assessment Taken"} arrow>
            <StatTypography>
              AT : <strong>{assessmentTaken}</strong>
            </StatTypography>
            </Tooltip>
            <Tooltip title={"Sale Amount"} arrow>
            <StatTypography>
              SA : <strong>{saleAmount}</strong>
            </StatTypography>
            </Tooltip>
            <Tooltip title={"Target Achievement Rate"} arrow>
            <StatTypography>
              TAR : <strong>{tar}</strong>
            </StatTypography>
            </Tooltip>
            <Tooltip title={"Admission Conversion Rate"} arrow>
            <StatTypography>
              ACR : <strong>{acr}</strong>
            </StatTypography>
            </Tooltip>
            <Tooltip title={"Admission Confirmed"} arrow>
            <StatTypography>
              AC : <strong>{admissinCount}</strong>
            </StatTypography>
            </Tooltip>
          

            
          </Box>
          <Box
       
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-F",
            }}
          >
            <Tooltip title={"Report Generated"} arrow>
            <StatTypography>
              RG : <strong>{assessmentReportGenerated}</strong>
            </StatTypography>
            </Tooltip>
            <Tooltip title={"Revenue Amount"} arrow>
            <StatTypography>
              RA : <strong>{revenue}</strong>
            </StatTypography>
            </Tooltip>
            <Tooltip title={"Slot Fullfillment Rate"} arrow>
            <StatTypography>
              SFR : <strong>{sfr}</strong>
            </StatTypography>
            </Tooltip>
            <Tooltip title={"Average Revenue Per User"} arrow>
            <StatTypography>
              ARPU : <strong>{arpu}</strong>
            </StatTypography>
            </Tooltip>
            <Tooltip title={"Admission UnConfirmed"} arrow>
            <StatTypography>
              AU : <strong>{admissinUnconfirmed}</strong>
            </StatTypography>
            </Tooltip>
          </Box>
        </Box>
      </GradientCard>
    );
  }
);

export default OgmDashboardCardView;
